import { useEffect } from 'preact/hooks'
import { route } from 'preact-router'
import { apiService } from '../services/api'
import type { ComponentChildren } from 'preact'

interface AuthGuardProps {
  children: ComponentChildren
}

export function AuthGuard({ children }: AuthGuardProps) {
  useEffect(() => {
    const hasCredentials = apiService.getCredentials() !== null
    if (!hasCredentials) {
      route('/')
    }
  }, [])

  const hasCredentials = apiService.getCredentials() !== null

  if (!hasCredentials) {
    return null // Don't render anything while redirecting
  }

  return <>{children}</>
}
